export default __webpack_public_path__ + "static/media/flag-virgin-islands-(u.s.).f5be6578.svg";